import { Row, Form, Col, Button, Table } from "react-bootstrap"
import Switch from "react-switch";

import React, { useRef, useState, useEffect } from 'react'
import { data } from "jquery";
import { Popover, Modal } from "antd";

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// Fonction pour réorganiser les éléments après un drag
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

const TableComponent = ({ data, setData, validated }) => {
    const [originalData, setOriginalData] = useState([])
    const [visible, setVisible] = useState(false);
    const [selectColonne, setSelectColonne] = useState('');

    const initRow = { columnName: "", columnType: "date", columnLength: 0, page_number: 1, research_key: false, columnContent: [] }

    useEffect(() => {
        setOriginalData([...data])
    }, [])

    // const updateData = (index, key, e) => {
    //     const newData = JSON.parse(JSON.stringify(data));
    //     if (key === "research_key") {
    //         newData[index][key] = e
    //     } else {
    //         newData[index][key] = e.target.value;
    //     }
    //     setData(newData);
    // }

    const updateData = (index, key, e) => {
        const newData = JSON.parse(JSON.stringify(data));
        if (key === "research_key") {
            newData[index][key] = e;

            if (e) {
                // Si research_key est coché
                // Trouver le prochain key_rang disponible
                const existingKeyRangs = newData
                    .filter(item => item.research_key && item.key_rang)
                    .map(item => item.key_rang);
                const nextKeyRang = Math.max(0, ...existingKeyRangs) + 1;
                newData[index]["key_rang"] = nextKeyRang;
            } else {
                // Si research_key n'est pas coché
                newData[index]["key_rang"] = ""; // Réinitialisé le key_rang
                // Reorganie key_rang 
                reorganizeKeyRang(newData);
            }
        } else {
            newData[index][key] = e.target.value;
        }
        setData(newData);
    };

    const reorganizeKeyRang = (data) => {
        const activeItems = data.filter(item => item.research_key);

        // Ranger les colonnes par key_rang
        activeItems.sort((a, b) => a.key_rang - b.key_rang);

        // Ré-assigner les nouvelles valeurs de key_rang aux différentes colonnes.
        for (let i = 0; i < activeItems.length; i++) {
            activeItems[i].key_rang = i + 1;
        }
    };

    const addRow = () => setData([...data, JSON.parse(JSON.stringify(initRow))])

    const addContent = (index, content, e) => {
        e.preventDefault();
        const newData = JSON.parse(JSON.stringify(data));
        newData[index].columnContent.push(content);
        setData(newData);
        e.target.reset();
    }

    const deleteContent = async (i, j) => {
        const newData = JSON.parse(JSON.stringify(data));
        newData[i].columnContent.splice(j, 1);
        setData(newData);
    }

    const deleteRow = (index) => {
        setVisible(true);
        setSelectColonne(index)
    }

    const onDragEnd = (result) => {
        if (!result.destination) return;
        const newData = reorder(data, result.source.index, result.destination.index);
        // Mettre à jour l'état avec le nouvel ordre
        setData(newData);
    };

    const columns = [
        { fieldName: 'Nom colonne', popover: "Nom de la colonne tel que vous souhaitez qu'il apparaisse dans la base de données." },
        { fieldName: 'Type', popover: "Le type de données (chaine de caractère, numerique ou date)." },
        { fieldName: 'Longueur', popover: "La longueur correspond au maximum du nombre de caractères que peut prendre le champ que l'on souhaite extraire." },
        { fieldName: 'Page', popover: "Le numéro de la page sur laquelle vous souhaitez extraire la donnée." },
        { fieldName: 'Clé de recherche', popover: "Permet de définir si la colonne est une clé de recherche pour le formulaire." },
        { fieldName: 'Corpus', popover: "Texte d'identification de la colonne tel qu'il apparait sur le formulaire. \nC'est le texte qui apparait avant la donnée à extraire. \nAttention sensible à la casse." },
        { fieldName: 'Actions', popover: false }
    ]

    const handleDeleteRow = async () => {
        const newData = JSON.parse(JSON.stringify(data));
        newData.splice(selectColonne, 1);
        setData(newData);
        setVisible(false);
    };
    const handleCancel = () => {
        setVisible(false)
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center head">
                <h3>Define form template</h3>
                <button type="button" onClick={addRow} className="add-btn"><i className="ti-plus mr-2"></i> Nouvelle colonne</button>
            </div>
            <div className="position-relative">
                <Table striped bordered className="formTable">
                    <thead>
                        <tr>
                            {columns.map(obj => (
                                <th>
                                    <div className="d-flex gap-2 align-items-center">
                                        {obj.fieldName}
                                        {obj.popover && <Popover placement="bottom" content={obj.popover}>
                                            <i className="ti-help border rounded-full w-5 h-5 grid place-items-center cursor-pointer" style={{ fontSize: 10 }} />
                                        </Popover>}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided) => (
                                <tbody {...provided.droppableProps} ref={provided.innerRef} className="w-full">
                                    {data?.map(({ column_name, type, length, research_key, contents }, index) =>
                                        <Draggable key={index} draggableId={`item-${index}`} index={index}>
                                            {(provided) => (
                                                <tr className="w-full"
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}>
                                                    <td><input disabled={(validated && originalData.some((x) => x.columnName === data[index].columnName))} value={data[index].columnName} onChange={(e) => updateData(index, "columnName", e)} type="text" /></td>
                                                    <td>
                                                        <Form>
                                                            <Form.Control value={data[index].columnType} onChange={(e) => updateData(index, "columnType", e)} as="select">
                                                                <option value="Date">Date</option>
                                                                <option value="numeric">Numeric</option>
                                                                <option value="string">texte</option>
                                                                <option value="textarea">texte long</option>
                                                                <option value="checkbox">checkbox</option>
                                                                <option value="dropdown_list">dropdown list</option>
                                                            </Form.Control>
                                                        </Form>

                                                        {/* <input value={data[index].columnType} onChange={(e) => updateData(index, "columnType", e)} type="text" /> */}

                                                    </td>
                                                    <td><input value={data[index].columnLength} onChange={(e) => updateData(index, "columnLength", e)} type="number" /></td>
                                                    <td><input value={data[index].page_number} onChange={(e) => updateData(index, "page_number", e)} type="number" /></td>
                                                    <td className="">
                                                        <div className="grid place-items-center h-full relative top-1">
                                                            <div className="flex items-center gap-4 w-full">
                                                                <Switch onChange={(e) => updateData(index, "research_key", e, data, setData)} checked={data[index].research_key} />
                                                                <input
                                                                    value={data[index].key_rang}
                                                                    onChange={(e) => updateData(index, "key_rang", e, data, setData)}
                                                                    type="number"
                                                                    className="border"
                                                                    readOnly={!data[index].research_key}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td><Contents deleteContent={deleteContent} index={index} data={data[index].columnContent} addContent={addContent} /></td>
                                                    <td className="text-center"><button type="button" onClick={() => deleteRow(index)} className="remove-btn text-white bg-red-600 p-1 px-2 rounded" title="delete"><i className="ti-trash"></i></button></td>
                                                </tr>
                                            )}
                                        </Draggable>
                                    )}
                                    {provided.placeholder}
                                </tbody>
                            )}
                        </Droppable>
                    </DragDropContext>
                </Table>
            </div>

            <Modal
                visible={visible}
                onOk={handleDeleteRow}
                onCancel={handleCancel}
                okText="Oui"
                cancelText="Non"
                okButtonProps={{ style: { backgroundColor: '#A31621', borderColor: '#A31621' } }}
            >
                <div className='text-black'>
                    <p className='text-black'>Êtes-vous sûr de vouloir supprimer cette colonne ?</p>
                </div>
            </Modal>
        </>
    )
}

const Contents = ({ data, addContent, index, deleteContent }) => {
    const inputRef = useRef()

    return (<form className="flex flex-col gap-1 contents-input" onSubmit={(e) => addContent(index, inputRef.current.value, e)}>
        <div className="flex flex-wrap gap-1">
            {data?.map((data, i) => <p className="p-1 pt-2 pr-3 bg-blue-200 rounded text-center text-black relative">{data}
                <span className="text-red-700 absolute top-0 right-0 pr-1 cursor-pointer font-bold" onClick={() => deleteContent(index, i)}>
                    X
                </span>
            </p>)}
            <input ref={inputRef} />
        </div>
    </form>)
}

export default TableComponent
